var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('span',[_c('img',{staticClass:"img-logo",attrs:{"src":require("@/assets/logo.png"),"height":"34","width":"34"}}),_c('span',{staticClass:"title ml-3 mr-5"},[_vm._v(" Séculos  "),_c('span',{staticClass:"font-weight-light"},[_vm._v("Admin")])])])
}]

export { render, staticRenderFns }